<template>
  <div style="background-color: #F8F9FB;text-align: center;">
    <hhead></hhead>
    <div class="crm_banner">
      <img
        class="img"
        src="../../../assets/images/crm/renzheng/ziti.png"
        alt=""
      />
      <div class="crm_search">
        <h4>您必须先注册或者加入机构才能使用杰宜斯云机构版</h4>
        <p>请先查询机构是否已注册</p>
        <label for="">
          <input
            type="text"
            v-model="jgName"
            ref="inputdata"
            placeholder="请输入机构名称查询是否已注册"
          />
          <li @click="serach">查询</li>
        </label>
      </div>
    </div>
    <div class="rz_banner">
      <span>System features</span>
      <h2>
        <img
          style="left: 5px;top: 8px;"
          src="../../../assets/images/crm/renzheng/left.png"
          alt=""
        />
        系统特点
        <img
          style="right: 5px;top: 8px;"
          src="../../../assets/images/crm/renzheng/right.png"
          alt=""
        />
      </h2>
      <img
        style="width: 120px;height: 1px;margin-bottom: 30px;margin-top: 10px;"
        src="../../../assets/images/crm/renzheng/hr.png"
        alt=""
      />
    </div>
    <ul class="No_block">
      <li>
        <img
          style="margin-bottom: 10px;width: 44px;height: 15px;"
          class="topimg"
          src="../../../assets/images/crm/renzheng/NO.1.png"
          alt=""
        />
        <img
          style="margin-bottom: 21px;margin-top: 48px;"
          class="z_img"
          src="../../../assets/images/crm/renzheng/tixing.png"
          alt=""
        />
        <h4>提醒功能</h4>
        <p>提醒功能设置，防止重要信息遗漏</p>
      </li>
      <li>
        <img
          style="width: 44px;height: 15px;"
          class="topimg "
          src="../../../assets/images/crm/renzheng/NO.2.png"
          alt=""
        />
        <img
          style="margin-bottom: 30px;margin-top: 39px;"
          class="z_img"
          src="../../../assets/images/crm/renzheng/shuju.png"
          alt=""
        />
        <h4>数据筛选，对比分析</h4>
        <p>大数据分析，更科学，更权威</p>
      </li>
      <li>
        <img
          style="margin-bottom: 14px;width: 44px;height: 15px;"
          class="topimg"
          src="../../../assets/images/crm/renzheng/NO.3.png"
          alt=""
        />
        <img
          style="margin-bottom: 30px;margin-top: 48px;"
          class="z_img"
          src="../../../assets/images/crm/renzheng/crm.png"
          alt=""
        />
        <h4>机构版管理数据</h4>
        <p>精准的数据化管理，方便简洁</p>
      </li>
    </ul>

    <!-- 弹出 -->
    <transition name="el-fade-in-linear">
      <div class="popContainer" v-show="join">
        <div class="add" :style="{ width: '460px', height: '260px' }">
          <div
            class="Top"
            :style="{ width: '460px', height: 0, border: 0 }"
          ></div>
          <span
            @click="cBtn"
            class="close iconfont icon-close_round_fill_bold
        "
          ></span>
          <img
            style="width: 86px;height: 86px;margin: 39px 0 15px 0;"
            v-show="state"
            src="../../../assets/images/crm/success.png"
            alt=""
          />
          <img
            v-show="!state"
            src="../../../assets/images/crm/err.png"
            alt=""
          />
          <p
            style="color: #0A101E;font-size: 16px;margin-bottom: 30px;"
            v-show="msg ? true : false"
          >
            {{ msg }}
          </p>
          <div
            style="width: 100px;color: #fff;height: 32px;border-radius: 2px;background-color: #5B85FF;line-height: 32px;margin: 0 auto 10px;cursor: pointer;"
            v-show="re_show"
            class="r_btn"
            @click="register"
          >
            立即注册
          </div>
          <div
            style="width: 100px;color: #fff;height: 32px;border-radius: 2px;background-color: #5B85FF;line-height: 32px;margin: 0 auto 10px;cursor: pointer;"
            v-show="apply_show"
            class="r_btn"
            @click="apply"
          >
            申请加入
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import hhead from "../header/index";
import "./style.css";
export default {
  components: { hhead },
  data() {
    return {
      jgName: "", //合作方名称
      msg: "", //查询后提示
      re_show: false,
      apply_show: false,
      entId: "", //申请企业ID
      join: false,
      state: true
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputdata.focus();
    });
  },
  methods: {
    register() {
      //立即注册按钮
      this.$router.push("/crm/authentication_t");
      this.$store.state.jgName = this.jgName;
    },
    cBtn() {
      this.join = false;
    },
    apply() {
      //申请加入
      this.$axios
        .post("/crm/mem/joinEnt", {
          apiToken: this.$store.state.usermsg.apiToken,
          entId: this.entId
        })
        .then(res => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.$alert("加入成功", {
              confirmButtonText: "确定",
              type: "success",
              center: true
            })
              .then(() => {
                this.$router.push("/crm/qyQuery/state");
              })
              .catch(() => {});
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    serach() {
      if (this.jgName) {
        this.$axios
          .post("/crm/ent/queryEnt", {
            key: this.jgName,
            apiToken: this.$store.state.usermsg.apiToken
          })
          .then(res => {
            this.join = true;
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.state = true;
              this.msg = "您的合作方已存在";
              this.apply_show = true;
              this.re_show = false;
              this.entId = res.data.data.id;
            } else {
              this.state = false;
              this.msg = "您的合作方不存在";
              this.re_show = true;
              this.apply_show = false;
            }
          })
          .catch(err => {
            this.$alert("查询失败", {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          });
      } else {
        this.$alert("请输入合作方名称", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/crm/qyQuery/index.vue